








































import "./team-card.less";
import Vue from "vue";
import AddClassHover from "./../common/add-class-hover.js";

export default Vue.extend({
  name: "team-card",
  props: {
    id: String,
    team: Object,
    archivedOrDeleted: Boolean,
  },
  directives: { AddClassHover },
  computed: {
    colorClass() {
      let trackingResult = (this as any).team.result;
      if (isNaN(trackingResult)) {
        return {
          "bio-card-default": true,
        };
      } else {
        return {};
      }
    },
    textColor() {
      let color = (this as any).color ? (this as any).color.toUpperCase() : (this as any).color;
      return !color || color === "#FFFFFF" || color === "#F5F2EE" ? "#515A6E" : "#FFFFFF";
    },
    color() {
      let context = this as any;

      if (context.team.archived === true) {
        return "#808080";
      }

      return !!context.team.color ? context.team.color : "#0178B5";
    },
    hasCompletedPercentage() {
      let context = this as any;
      return context.team.completedPercentage !== null && !isNaN(context.team.completedPercentage);
    },
  },
  methods: {
    handleCardClick() {
      this.$router.push({ name: "team", params: { id: this.team.id } });
    },
    handleMenuItemClick(name) {
      this.$emit(name);
    },
  },
});
